import AnnouncementBar from '../home/components/AnnouncementBar';
import Navbar from '../home/components/Navbar';
import FooterSection from '../home/components/FooterSection';
import SEOHead from '../../components/feature/SEOHead';
import { SITE_URL } from '../../utils/seo';

const protectFrom = [
  'Birden Fazla Sürücü Arızası',
  'Birden Fazla Sunucu Arızası',
  'Karmaşık Kurtarma Senaryoları',
];

const delivers = [
  'Birden Fazla Sürücü veya Sunucu Arızası Sırasında Gerçek Zamanlı Veri Teslimi',
  'Sürücü Değişiminde Verinin Satır İçi Geri Yüklenmesi',
  'VergeOS\'a Entegre — Ek Maliyet Yok',
];

const continuousBackups = [
  { title: 'Sürekli Yedeklemeler', desc: 'Veri ioGuardian sunucusuna neredeyse sürekli gönderilebilir: her saat, her 30 dakika, her 15 dakika. Ortamınız için en uygun koruma stratejisini tasarlayın.' },
  { title: 'Global Satır İçi Tekilleştirme', desc: 'VergeOS\'un gelişmiş tekilleştirme teknolojisinden hem üretim hem de yedekleme depolamada yararlanın. Kapasite kullanımını minimize edin; yalnızca benzersiz veri segmentleri ana VergeOS örneğinden ioGuardian Sunucusuna aktarılır.' },
  { title: 'VergeOS\'a Entegre', desc: 'ioGuardian\'ın yetenekleri VergeOS\'a sorunsuz entegre edilmiştir; yalnızca bir özel sunucunun ioGuardian hedefi olarak eklenmesi yeterlidir. Bu entegrasyon dağıtımı ve yönetimi basitleştirir, her ölçekteki işletme için verimli bir çözüm sunar.' },
];

const recoveryPoints = [
  { title: 'Satır İçi Kurtarma', desc: 'Geleneksel yedekleme çözümlerinin aksine ioGuardian, eksik veri segmentlerini gerçek zamanlı olarak sanal makinelere göndererek kesinti süresini önemli ölçüde azaltır ve iş sürekliliğini artırır.' },
  { title: 'Değiştirilen Sürücülerin Hızlı Kurtarması', desc: 'Sürücü değişiminde veriler doğrudan ioGuardian Sunucusundan beslenerek üretim performansına minimum etki ile tam korumalı duruma hızlı dönüş sağlanır.' },
  { title: 'Maksimum Saklama Süresi', desc: 'VergeOS Anlık Görüntülerini kullanarak üretim ortamının nokta-zamanlı kopyaları üretim performansına etki etmeksizin süresiz saklanabilir.' },
  { title: 'Esnek Depolama Seçenekleri', desc: 'ioGuardian, sabit disk sürücüleri ve flash depolamanın kullanımına olanak tanır; tüm flash üretim VergeOS ortamlarında bile asenkron veri aktarımı ile esnek ve ekonomik depolama kapasitesi sunar.' },
];

const ioguardianJsonLd = { '@context': 'https://schema.org', '@type': 'SoftwareApplication', name: 'ioGuardian', applicationCategory: 'BusinessApplication', operatingSystem: 'Any', description: 'ioGuardian ile sürekli veri koruması (CDP). Eş zamanlı disk arızalarına karşı koruma ve sıfır veri kaybı.', url: `${SITE_URL}/ioguardian` };

export default function IoGuardianPage() {
  return (
    <div className="min-h-screen w-full bg-white">
      <SEOHead title="ioGuardian | Sürekli Veri Koruması (CDP) | VergeOS" description="ioGuardian ile sürekli veri koruması. Eş zamanlı disk ve sunucu arızalarına karşı tam koruma, sıfır veri kaybı ve hızlı kurtarma." keywords="ioGuardian, CDP, sürekli veri koruması, VergeOS, veri güvenliği, sıfır veri kaybı" canonicalPath="/ioguardian" jsonLd={ioguardianJsonLd} />
      <AnnouncementBar />
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative w-full overflow-hidden bg-[#0f1117] py-24 text-center">
          <div className="absolute inset-0 opacity-20" style={{ backgroundImage: 'repeating-linear-gradient(45deg,#e8600a 0,#e8600a 1px,transparent 0,transparent 50%)', backgroundSize: '20px 20px' }} />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0f1117]/60 to-[#0f1117]/90" />
          <div className="relative z-10 max-w-4xl mx-auto px-6">
            <div className="inline-block bg-[#e8600a]/20 text-[#e8600a] text-xs font-semibold uppercase tracking-widest px-4 py-1.5 rounded-full mb-6">Özellikler</div>
            <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4 leading-tight">
              <span className="text-[#e8600a]">ioGuardian</span> for VergeOS
            </h1>
            <p className="text-xl text-gray-300 mb-3 font-medium">Anlık Kurtarmanın Ötesine Geçin — Gerçek Zamanlı Kurtarma</p>
          </div>
        </section>

        {/* Intro */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-16 items-center">
              <div>
                <div className="flex items-center gap-6 mb-8">
                  <div className="w-20 h-20 flex items-center justify-center bg-[#f8fafc] rounded-xl border border-gray-200">
                    <i className="ri-safe-line text-4xl text-[#e8600a]"></i>
                  </div>
                  <div>
                    <p className="font-bold text-[#1e293b] text-xl">ioGuardian</p>
                    <p className="text-gray-500 text-sm">For VergeOS</p>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-6">
                  <div>
                    <p className="font-semibold text-[#1e293b] mb-3 text-sm">Koruyan:</p>
                    <ul className="space-y-2">
                      {protectFrom.map(item => (
                        <li key={item} className="flex items-start gap-2 text-sm text-gray-700">
                          <i className="ri-shield-check-line text-[#e8600a] text-base shrink-0 mt-0.5"></i>{item}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <p className="font-semibold text-[#1e293b] mb-3 text-sm">ioGuardian Sağlar:</p>
                    <ul className="space-y-2">
                      {delivers.map(item => (
                        <li key={item} className="flex items-start gap-2 text-sm text-gray-700">
                          <i className="ri-check-double-line text-[#e8600a] text-base shrink-0 mt-0.5"></i>{item}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
              <div className="rounded-xl overflow-hidden">
                <img src="https://public.readdy.ai/ai/img_res/82b62b6225a764a99fe43fc360399d47.jpg" alt="ioGuardian Mimarisi" className="w-full h-full object-top" />
              </div>
            </div>
          </div>
        </section>

        {/* Continuous Backups */}
        <section className="py-20 bg-[#f8fafc]">
          <div className="max-w-6xl mx-auto px-6">
            <h2 className="text-3xl font-bold text-[#1e293b] text-center mb-12">Temel Özellikler</h2>
            <div className="grid md:grid-cols-3 gap-6">
              {continuousBackups.map(cb => (
                <div key={cb.title} className="bg-white rounded-lg border border-gray-100 p-6">
                  <h3 className="font-semibold text-[#1e293b] mb-3 text-sm">{cb.title}</h3>
                  <p className="text-xs text-gray-600 leading-relaxed">{cb.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Recovery Features */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-16 items-start">
              <div className="rounded-xl overflow-hidden">
                <img src="https://readdy.ai/api/search-image?query=ioGuardian%20inline%20recovery%20visualization%20showing%20VergeOS%20production%20environment%20with%20real-time%20data%20segments%20being%20delivered%20to%20virtual%20machines%20from%20ioGuardian%20server%20during%20drive%20failure%2C%20business%20continuity%20maintained%20technical%20diagram%20dark%20background%20orange%20highlights%20enterprise%20data%20protection&width=580&height=440&seq=ioguardian_recovery1&orientation=landscape" alt="ioGuardian Kurtarma" className="w-full h-full object-top" />
              </div>
              <div>
                <h2 className="text-3xl font-bold text-[#1e293b] mb-8">Gelişmiş Kurtarma Yetenekleri</h2>
                <div className="space-y-5">
                  {recoveryPoints.map(rp => (
                    <div key={rp.title} className="border-l-2 border-[#e8600a] pl-4">
                      <p className="font-semibold text-[#1e293b] mb-1 text-sm">{rp.title}</p>
                      <p className="text-xs text-gray-600 leading-relaxed">{rp.desc}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-16 bg-[#0f1117]">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <h2 className="text-3xl font-bold text-white mb-4">VergeOS'un Üstün Veri Dayanıklılığı ve Korumasını Keşfedin</h2>
            <p className="text-gray-400 mb-8 text-sm">ioGuardian ile diğer hiper yöneticilere kıyasla VergeOS'un nasıl üstün veri dayanıklılığı ve koruma sağladığını öğrenmek için bir Teknik Whiteboard seansı planlayın.</p>
          </div>
        </section>
      </main>
      <FooterSection />
    </div>
  );
}
